import React from "react"
import { DateTime } from "luxon"
import i18n from "@/i18n"
import { type OpeningHour } from "@/utils/opening_hours"
import ReservationSidebarCalendar from "./calendar"

type DateStepProps = {
  date: DateTime | null
  timezone: string
  country: string
  openingHours?: OpeningHour[]
  onDateChange: (date: DateTime) => void
  onContinue: () => void
  showContinueButton?: boolean
}

const ACTION_BUTTON_STYLES =
  "mt-5 flex h-[34px] w-full items-center justify-center rounded-[5px] bg-[#2596fa] text-sm font-medium text-white transition-colors hover:bg-[#1f84dd] disabled:cursor-not-allowed disabled:bg-[rgba(37,150,250,0.6)]"

const DateStep: React.FC<DateStepProps> = ({
  date,
  timezone,
  country,
  openingHours,
  onDateChange,
  onContinue,
  showContinueButton = true,
}) => {
  return (
    <div className="flex flex-col" data-testid="public-venue-sidebar-date-step">
      <ReservationSidebarCalendar
        value={date}
        timezone={timezone}
        country={country}
        openingHours={openingHours}
        onChange={onDateChange}
      />

      {showContinueButton && (
        <button
          type="button"
          onClick={onContinue}
          disabled={!date || !date.isValid}
          className={ACTION_BUTTON_STYLES}
          data-testid="public-venue-sidebar-date-continue"
        >
          {i18n.t("app.public.venue.sidebar.select_date")}
        </button>
      )}
    </div>
  )
}

export default DateStep
